/**
 * 达人订单详情页 - 费用明细（基于接口字段：original_price / coupon_price / discount_price / pay_price）
 */

interface PriceDetailProps {
  /** 产品原价 */
  originalPrice: number;
  /** 实付金额 */
  payPrice: number;
  /** 优惠抵扣总额（coupon_price + discount_price） */
  discount: number;
  /** 优惠券金额（单独展示时传入） */
  couponPrice?: number;
  /** 折扣减免金额（单独展示时传入） */
  discountPrice?: number;
  showPriceDetail: boolean;
  onToggle: () => void;
}

export default function PriceDetail({
  originalPrice,
  payPrice,
  discount,
  couponPrice = 0,
  discountPrice = 0,
  showPriceDetail,
  onToggle,
}: PriceDetailProps) {
  return (
    <div
      className="mx-4 mt-3 bg-white rounded-2xl overflow-hidden cursor-pointer"
      onClick={onToggle}
    >
      <div className="w-full flex items-center justify-between px-4 py-3.5">
        <span className="text-sm font-bold text-gray-900">费用明细</span>
        <div className="flex items-center gap-2">
          <span className="font-bold text-base" style={{ color: "#EF4444" }}>
            ¥{payPrice.toFixed(2)}
          </span>
          <i
            className="ri-arrow-down-s-line transition-transform duration-200"
            style={{
              fontSize: 16,
              color: "#9CA3AF",
              transform: showPriceDetail ? "rotate(180deg)" : "rotate(0)",
            }}
          />
        </div>
      </div>
      {showPriceDetail && (
        <div
          className="px-4 pb-3 space-y-2 border-t"
          style={{ borderColor: "#F5F5F5" }}
        >
          <div className="flex justify-between py-1.5 text-sm">
            <span style={{ color: "#6B7280" }}>产品原价</span>
            <span className="font-medium text-gray-900">¥{originalPrice.toFixed(2)}</span>
          </div>

          {/* 有单独的优惠券/折扣数据时分行显示 */}
          {(couponPrice > 0 || discountPrice > 0) ? (
            <>
              {couponPrice > 0 && (
                <div className="flex justify-between py-1.5 text-sm">
                  <span style={{ color: "#6B7280" }}>优惠券</span>
                  <span className="font-medium" style={{ color: "#10B981" }}>-¥{couponPrice.toFixed(2)}</span>
                </div>
              )}
              {discountPrice > 0 && (
                <div className="flex justify-between py-1.5 text-sm">
                  <span style={{ color: "#6B7280" }}>折扣减免</span>
                  <span className="font-medium" style={{ color: "#10B981" }}>-¥{discountPrice.toFixed(2)}</span>
                </div>
              )}
            </>
          ) : (
            /* 无明细时合并为优惠抵扣一行 */
            discount > 0 && (
              <div className="flex justify-between py-1.5 text-sm">
                <span style={{ color: "#6B7280" }}>优惠抵扣</span>
                <span className="font-medium" style={{ color: "#10B981" }}>-¥{discount.toFixed(2)}</span>
              </div>
            )
          )}

          <div
            className="flex justify-between py-2 text-sm border-t font-bold"
            style={{ borderColor: "#F5F5F5" }}
          >
            <span style={{ color: "#374151" }}>实付金额</span>
            <span style={{ color: "#EF4444", fontSize: 16 }}>¥{payPrice.toFixed(2)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
